// Copyright (c) Zammo Inc.
import React from 'react';
import { ZammoWebChat } from '@bfc/zammo/lib/ui-components/ZammoWebChat';

import { getSimulatorSession, getSimulatorSpeechSession, SimulatorSession } from '../../app/actions';

interface Props {
  /**
   * @property {string} session simulator session containing details needed to connect to Zammo business.
   */
  session: SimulatorSession;

  /**
   * @property {string} simulatorToken the token generated by the zammo API to authenticate the business with Zammo business.
   */
  simulatorToken: string;
}

const Simulator = ({ simulatorToken, session }: Props) => {
  const getDirectlineToken = async (userId: string) => {
    const data = await getSimulatorSession(simulatorToken, userId);

    return data.directLineToken;
  };

  const getSpeechSessionInfo = async () => {
    const speechSession = await getSimulatorSpeechSession(simulatorToken);

    return { token: speechSession.speechToken, region: speechSession.speechRegion };
  };

  const getSimulatorToken = async () => {
    return simulatorToken;
  };

  const getExtensionContent = async () => ({
    js: session.customJsContent as string,
    css: session.customCssContent as string,
  });

  return (
    <ZammoWebChat
      getDirectlineToken={getDirectlineToken}
      getSpeechSessionInfo={getSpeechSessionInfo}
      scriptCssUrl={session.uiKitStyleUrl as string}
      scriptSrcUrl={session.uiKitScriptUrl as string}
      zammoApiBaseUrl={window.ZAMMO_API_URL}
      isStandAlone={true}
      getSimulatorToken={getSimulatorToken}
      getExtensionContent={getExtensionContent}
    />
  );
};

export default Simulator;
